import { Box, Button, Typography } from '@mui/material';
import Image from '../Image/Image';
import { usePage } from 'contexts/Page/Page';
import { useTheme } from 'contexts/Theme/Theme';
import { useMemo } from 'react';
import * as setup from 'setup';

export default function Intro({ lesson }: IntroProps) {
    const page = usePage();
    const theme = useTheme();
    const pageLesson = lesson || page.lesson;

    const lessonContent = useMemo(() => {
        return ((pageLesson && setup.lessons[pageLesson]) || null) as IntroContent | null;
    }, [pageLesson]);

    return (
        <Box
            sx={{
                flex: 1,
                marginTop: 10,
                textAlign: 'center'
            }}>
            <Typography
                color={theme.darkMode ? '#FFF' : 'rgba(8,8,8,0.5)'}
                variant="montserrat614"
                sx={{
                    marginBottom: 2
                }}>
                {lessonContent?.heading}
            </Typography>
            <Typography
                color={theme.darkMode ? '#FFF' : '#1375BC'}
                dangerouslySetInnerHTML={{ __html: lessonContent?.title || '' }}
                component="h1"
                variant="montserrat828"
                sx={{
                    marginBottom: 5
                }}
            />
            <Typography
                component="div"
                dangerouslySetInnerHTML={{ __html: lessonContent?.text || '' }}
                variant="montserrat518"
                sx={{
                    marginBottom: 8
                }} />
            <Button size="large" onClick={() => page.show(`${pageLesson}.1`)}>
                {lessonContent?.button}
            </Button>
            {lessonContent?.image && (
                <Box
                    sx={{
                        marginX: 'auto',
                        marginTop: 8,
                        maxWidth: 360,
                        width: '100%'
                    }}>
                    <Image alt={lessonContent?.imageAlt} src={lessonContent.image} />
                </Box>
            )}
        </Box>
    );
}
